import React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import FormNuevaCita from "./FormNuevaCita";
import { Toast, ToastContainer } from "react-bootstrap";
import { leadingZero, getAmpm, getHoraCita, convertirHoraMilitarA12h, convertirHoraEtiqueta, getElementosHora } from "../../../resources/Helper";
import AgendaTooltip from "../custom/AgendaTooltip";
import CustomSwitch from "../custom/CustomSwitch";

function VistaPorRecursos(props) {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [recursos, setRecursos] = useState([]);
    const [todosLosRecursos, setTodosLosRecursos] = useState([]); // Lista completa sin filtrar
    const [recursosSeleccionados, setRecursosSeleccionados] = useState([]); // IDs de recursos seleccionados
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const [alturaAgendaRecursos, setAlturaAgendaRecursos] = useState();
    const [bloquesMinutos, setBloquesMinutos] = useState();
    const [contenidoRecursos, setContenidoRecursos] = useState();
    const [etiquetasHoras, setEtiquetasHoras] = useState();

    const [fechaAgendaRecursos, setFechaAgendaRecursos] = useState();
    const [fechaUnix, setFechaUnix] = useState();

    const [stepCita, setStepCita] = useState();


    ////////////////////////////////////////////////////

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [extendedProps, setExtendedProps] = useState({});
    const [idCita, setIdCita] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');
    const [idUsuarioAgenda, setIdUsuarioAgenda] = useState('');
    const [idUnidadAgenda, setIdUnidadAgenda] = useState('');
    const [primeraVez, setPrimeraVez] = useState();
    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();
    const [profesionalAsignado, setProfesionalAsignado] = useState();
    const [usuarioAgenda, setUsuarioAgenda] = useState();
    const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState('');
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState('');
    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);

    const [tooltipTop, setTooltipTop] = useState();
    const [tooltipLeft, setTooltipLeft] = useState();
    const [tooltipDisplay, setTooltipDisplay] = useState('none');
    const [contenidoTooltip, setContenidoTooltip] = useState('');

    // Estados para horarios de agenda
    const [horaInicio, setHoraInicio] = useState(0); // Hora en formato 24h (0-23)
    const [horaFin, setHoraFin] = useState(24); // Hora en formato 24h (0-24)

    ////////////////////////////////////////////////////


    let userdata = [];

    const SCALE_MINUTOS_POR_PIXEL = 1.6; // 30 mins = 18.75px
    const SLOT_DURACION = 30;

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setStepCita(userdata.step);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {

                console.log(error);
            });

        // ✅ Cargar horarios de agenda
        axios.get('/horario-agenda')
            .then(response => {
                if (response.status === 200) {
                    const inicio = parseInt(response.data.hora_inicio.split(':')[0]);
                    const fin = parseInt(response.data.hora_fin.split(':')[0]);
                    
                    // Si es el rango por defecto (00:00 - 23:59), usar 24 horas completas
                    if (inicio === 0 && fin === 23) {
                        setHoraInicio(0);
                        setHoraFin(24);
                    } else {
                        setHoraInicio(inicio);
                        setHoraFin(fin + 1); // +1 para incluir la última hora
                    }
                }
            })
            .catch(error => {
                console.log('Usando horarios por defecto (24h)');
            });


        ////////////////////////////////

        crearBloquesMinutos(SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL);

        let fechaHoy = new Date();
        let dia = fechaHoy.getDate();
        let mes = fechaHoy.getMonth() + 1;
        let anyo = fechaHoy.getFullYear();

        let fechaAgenda = anyo + '-' + leadingZero(mes) + '-' + leadingZero(dia);

        setFechaAgendaRecursos(fechaAgenda);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: fechaAgenda
            }
        }

        axios.get('citas-profesionales-dia', config2)
            .then(response => {
                if (response.status === 200) {
                    setTodosLosRecursos(response.data);
                    // Inicialmente seleccionar todas las agendas
                    const idsAgendas = response.data.map(agenda => agenda.agenda_id || agenda.id);
                    setRecursosSeleccionados(idsAgendas);
                    setRecursos(response.data);
                }
            })
            .catch(error => console.log(error))


        setFechaUnix(new Date().getTime());

    }, []);



    useEffect(() => {
        renderizarRecursos(SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL, recursos);
    }, [recursos]);

    // ✅ Regenerar bloques cuando cambien los horarios
    useEffect(() => {
        if (horaInicio !== 0 || horaFin !== 24) {
            crearBloquesMinutos(SLOT_DURACION, SCALE_MINUTOS_POR_PIXEL);
        }
    }, [horaInicio, horaFin]);

    // Efecto para filtrar recursos cuando cambian las selecciones
    useEffect(() => {
        if (todosLosRecursos.length > 0) {
            const recursosFiltrados = todosLosRecursos.filter(agenda =>
                recursosSeleccionados.includes(agenda.agenda_id || agenda.id)
            );
            setRecursos(recursosFiltrados);
        }
    }, [recursosSeleccionados, todosLosRecursos]);


    useEffect(() => {
        cargarCitas(fechaAgendaRecursos);
    }, [fechaAgendaRecursos]);


    function handleFecha(dias) {

        let c = dias * 86400000;
        let nuevaFecha = new Date(fechaUnix + c);
        setFechaUnix(fechaUnix + c);

        let fc = new Date(fechaUnix + c);

        let dia = fc.getDate();
        let mes = fc.getMonth() + 1;
        let anyo = fc.getFullYear();

        setFechaAgendaRecursos(anyo + '-' + leadingZero(mes) + '-' + leadingZero(dia));
    }

    function handleFechaDirecta(fechaSeleccionada) {
        // Convertir la fecha seleccionada a timestamp Unix
        let fechaObj = new Date(fechaSeleccionada + 'T00:00:00');
        setFechaUnix(fechaObj.getTime());
        setFechaAgendaRecursos(fechaSeleccionada);
    }


    const handleClicCalendar = (e, agenda) => {  // ← Cambiado de "citas" a "agenda"
        let rect = e.target.getBoundingClientRect();
        let y = (e.clientY - rect.top) - 36;
        let duracionBloquePixels = parseInt(SLOT_DURACION / SCALE_MINUTOS_POR_PIXEL);
        let slot = parseInt(y / duracionBloquePixels);

        // ✅ Calcular minutos desde el inicio configurado
        let minutoDia = (horaInicio * 60) + (stepCita * slot);

        let horaNuevaCita = parseInt(minutoDia / 60);
        let minutoNuevaCita = minutoDia % 60;
        let fechaNuevaCita = leadingZero(horaNuevaCita) + ':' + leadingZero(minutoNuevaCita) + ':00';

        setDate(fechaAgendaRecursos);
        setHoraAtencionCita(getHoraCita(horaNuevaCita));
        setMinutoCita(leadingZero(minutoNuevaCita));
        setAmpmCita(getAmpm(horaNuevaCita));

        // Usar agenda_id en lugar de id
        setProfesionalAsignado(agenda.agenda_id);

        // Usar nombre_agenda
        setNombreProfesionalAsignado(agenda.nombre_agenda);

        setModalState('visible');
    }

    function renderizarRecursos(duracionBloque, minutosPorPixel, arrayCitas) {

        // ✅ Calcular altura basada en el rango configurado
        const minutosRango = (horaFin - horaInicio) * 60;
        let h = parseInt(minutosRango / minutosPorPixel);
        let duracionBloquePixels = parseInt(duracionBloque / minutosPorPixel);
        let alturaCalculada = h + 36; // Misma altura que el contenedor

        let citasJSX = [];

        arrayCitas.map((agenda) => {  // ← Cambiado de "citas" a "agenda"
            console.log(agenda.id);
            let bloqueRecurso = <div className="columna-recursos" onClick={(e) => handleClicCalendar(e, agenda)} style={{ height: alturaCalculada + 'px' }}>
                {/* Usar nombre_agenda en lugar de nombre */}
                <div className="encabezado-recurso">{agenda.nombre_agenda}</div>
                {
                    agenda.citas.map((cita) => {
                        // ✅ Filtrar citas fuera del rango configurado
                        let horaCita = parseInt(cita.hora_cita.split(':')[0]);
                        if (horaCita >= horaInicio && horaCita < horaFin) {
                            // Determinar si es un bloqueo (sin paciente)
                            const esBloqueo = !cita.primer_nombre || !cita.primer_apellido;
                            
                            // Determinar el texto a mostrar
                            let textoCita = esBloqueo 
                                ? 'Agenda Bloqueada' 
                                : `${cita.primer_nombre} ${cita.primer_apellido}`;
                            
                            return <div
                                key={cita.id}
                                className="cita-recursos"
                                onClick={() => !esBloqueo && handleClicCita(cita)}
                                onMouseEnter={(e) => !esBloqueo && handleMouseEnter(e, cita)}
                                onMouseLeave={handleMouseLeave}
                                style={{ 
                                    top: getPosYCita(cita, minutosPorPixel) + 'px', 
                                    height: getAlturaCita(cita, minutosPorPixel) + 'px', 
                                    backgroundColor: cita.color ? cita.color : '#b8b8b8',
                                    cursor: esBloqueo ? 'default' : 'pointer'
                                }}
                            >
                                {convertirHoraMilitarA12h(cita.hora_cita)} - {textoCita}
                            </div>
                        }
                        return null;
                    })
                }
            </div>;
            citasJSX.push(bloqueRecurso);
        })

        setContenidoRecursos(citasJSX);
    }


    function getPosYCita(cita, minutosPorPixel) {
        let tiempoInicio = (60 * parseInt(cita.hora_cita.split(':')[0])) + parseInt(cita.hora_cita.split(':')[1]);
        // ✅ Restar el offset del inicio configurado
        let minutosOffset = horaInicio * 60;
        let tiempoRelativo = tiempoInicio - minutosOffset;
        let posY = parseInt(tiempoRelativo / minutosPorPixel);
        return posY + 36;
    }

    function getAlturaCita(cita, minutosPorPixel) {
        let h = cita.duracion_cita;
        return parseInt(h / minutosPorPixel);
    }

    function crearBloquesMinutos(duracionBloque, minutosPorPixel) {

        // ✅ Calcular minutos totales basados en el rango configurado
        const minutosRango = (horaFin - horaInicio) * 60;
        let h = parseInt(minutosRango / minutosPorPixel);
        let duracionBloquePixels = parseInt(duracionBloque / minutosPorPixel);
        let cantidadBloques = parseInt(h / duracionBloquePixels);
        let bloquesPorHora = 60 / duracionBloque;

        setAlturaAgendaRecursos(h + 36);

        let bloques = '';
        let etiquetas = '';

        for (let k = 0; k < cantidadBloques; k++) {
            let estiloBloqueHora = '';
            let j = k + 1;
            let i = j % bloquesPorHora;
            if (i == 0) {
                // ✅ Calcular hora relativa al inicio configurado
                let valorHoraRelativa = (j * duracionBloque) / 60;
                let valorHoraAbsoluta = horaInicio + valorHoraRelativa;
                let posYEtiqueta = (valorHoraRelativa * duracionBloquePixels * bloquesPorHora) - 9 + 36;
                estiloBloqueHora = ' border-bottom: 1px solid #e1e1e1; width: 100%;';
                if (valorHoraAbsoluta < horaFin) {
                    etiquetas += "<span class='etiqueta-hora' style='top: " + posYEtiqueta + "px'>" + convertirHoraEtiqueta(valorHoraAbsoluta) + "</span>";
                }
            } else {
                estiloBloqueHora = ' width: 100%; border-bottom: 1px dotted #e1e1e1;';
            }
            bloques += "<div class='bloque-minutos' style='height:" + duracionBloquePixels + "px; " + estiloBloqueHora + "'></div>";
        }

        setEtiquetasHoras(etiquetas);
        setBloquesMinutos(bloques);
    }

    function cargarCitas() {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                fecha: fechaAgendaRecursos
            }
        }

        axios.get('citas-profesionales-dia', config)
            .then(response => {
                if (response.status === 200) {
                    setTodosLosRecursos(response.data);
                    // Mantener selecciones actuales o seleccionar todas si es la primera carga
                    if (recursosSeleccionados.length === 0) {
                        const idsAgendas = response.data.map(agenda => agenda.agenda_id || agenda.id);
                        setRecursosSeleccionados(idsAgendas);
                    }
                }
            })
            .catch(error => console.log(error))
    }

    function handleClicCita(cita) {
        setDate(cita.fecha_cita);
        setTime(cita.hora_cita);
        setPrimerNombre(cita.primer_nombre);
        setSegundoNombre(cita.segundo_nombre);
        setPrimerApellido(cita.primer_apellido);
        setSegundoApellido(cita.segundo_apellido);
        setEmail(cita.email);
        setCelular(cita.celular);
        setTipoDocumento(cita.tipo_documento);
        setNumeroDocumento(cita.numero_documento);
        setIdPaciente(cita.id_paciente);
        setDuracionCita(cita.duracion_cita);
        setEstadoCita(cita.estado_cita);
        setIdEstadoCita(cita.id_estado_cita);
        setUnidadAtencion(cita.id_unidad_atencion);
        setMotivoConsulta(cita.motivo_consulta);
        setVerCita(true);
        setPrimeraVez(false);
        setIdCita(cita.id);
        setHoraAtencionCita(getElementosHora(cita.hora_cita)[0]);
        setMinutoCita(getElementosHora(cita.hora_cita)[1]);
        setAmpmCita(getElementosHora(cita.hora_cita)[2]);

        // El backend ya debe estar enviando id_users correctamente para la cita
        setProfesionalAsignado(cita.id_users);

        setIdUsuarioAgenda(cita.id_usuario_asigna);

        // Usar nombre_agenda si está disponible, sino otro campo
        setNombreProfesionalAsignado(cita.nombre_agenda || 'Nombre no disponible');

        setNombreUsuarioAsigna((cita.nombre_usuario_agenda || '') + ' ' + (cita.apellido_usuario_agenda || ''));

        if (cita.estado == '1') {
            setPuedeAtender(true);
        }
        else {
            setPuedeAtender(false);
        }

        if (cita.estado_cita != null) {
            setModalState('visible');
        }
    }


    function toastCita(msg) {

        setToastMsg(msg);
        setTimeout(() => { setShowToast(true) }, 800);
    }

    // Funciones para manejar filtros de agendas
    const toggleRecurso = (agendaId) => {
        setRecursosSeleccionados(prev => {
            if (prev.includes(agendaId)) {
                return prev.filter(id => id !== agendaId);
            } else {
                return [...prev, agendaId];
            }
        });
    };

    const seleccionarTodas = () => {
        const idsAgendas = todosLosRecursos.map(agenda => agenda.agenda_id || agenda.id);
        setRecursosSeleccionados(idsAgendas);
    };

    const deseleccionarTodas = () => {
        setRecursosSeleccionados([]);
    };

    function handleMouseEnter(e, cita) {
        // Si no es bloqueo, procesar como cita normal
        let np = cita.segundo_nombre ? cita.primer_nombre + " " + cita.segundo_nombre : cita.primer_nombre;
        
        // Manejar segundo_apellido que puede ser null, "null" o vacío
        let segundoApellido = cita.segundo_apellido;
        let ap = cita.primer_apellido;
        if (segundoApellido && segundoApellido !== 'null' && segundoApellido.trim() !== '') {
            ap += " " + segundoApellido;
        }

        let rect = e.target.getBoundingClientRect();

        // Ajuste de posición para que no se salga de la pantalla
        let left = rect.left;
        if (left + 300 > window.innerWidth) {
            left = window.innerWidth - 320;
        }

        let contenidott = `<p><strong>Paciente: </strong>${np + ' ' + ap}</p>
                            <p><strong>Documento: </strong>${cita.numero_documento || ''}</p>
                            <p><strong>Estado: </strong>${cita.estado_cita || ''}</p>
                            <p><strong>Motivo: </strong>${cita.motivo_consulta || ''}</p>
                            <p><strong>Celular: </strong>${cita.celular || ''}</p>`;

        setContenidoTooltip(contenidott);
        setTooltipTop((rect.bottom + 10) + 'px');
        setTooltipLeft(left + 'px');
        setTooltipDisplay('block');
    }

    function handleMouseLeave() {
        setTooltipDisplay('none');
    }

    const toggleMostrarFiltros = () => {
        setMostrarFiltros(!mostrarFiltros);
    };



    if (loggedIn) {

        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="calendar" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/agenda">Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Agenda por recursos</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Agenda por profesionales</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <div className="row encabezado-agenda-recursos">
                                        <div className="col-md-3 navegacion-agenda-recursos fc-button-group">
                                            <button className="btn-atras" onClick={() => handleFecha(-1)}><span className="fc-icon fc-icon-chevron-left"></span></button>
                                            <button className="btn-adelante" onClick={() => handleFecha(1)}><span className="fc-icon fc-icon-chevron-right"></span></button>
                                        </div>
                                        <div className="col-md-3">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaAgendaRecursos}
                                                onChange={(e) => handleFechaDirecta(e.target.value)}
                                                style={{ fontSize: '14px' }}
                                            />
                                        </div>
                                        <div className="col-md-3 fecha-actual-agenda-recursos">{fechaAgendaRecursos}</div>
                                        <div className="col-md-3 text-right">
                                            <button
                                                className="btn btn-outline-info btn-sm"
                                                onClick={toggleMostrarFiltros}
                                            >
                                                <i className="fas fa-filter"></i> Filtrar Agendas ({recursosSeleccionados.length}/{todosLosRecursos.length})
                                            </button>
                                        </div>
                                    </div>

                                    {/* Panel de Filtros */}
                                    {mostrarFiltros && (
                                        <div className="card card-info card-outline mb-3">
                                            <div className="card-header">
                                                <h5 className="card-title">
                                                    <i className="fas fa-filter"></i> Seleccionar Agendas a Mostrar
                                                </h5>
                                                <div className="card-tools">
                                                    <button
                                                        className="btn btn-sm btn-success mr-2"
                                                        onClick={seleccionarTodas}
                                                    >
                                                        <i className="fas fa-check-double"></i> Todas
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-warning mr-2"
                                                        onClick={deseleccionarTodas}
                                                    >
                                                        <i className="fas fa-times"></i> Ninguna
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-secondary"
                                                        onClick={toggleMostrarFiltros}
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    {todosLosRecursos.map((agenda, index) => (
                                                        <div key={agenda.agenda_id || agenda.id} className="col-md-3 col-sm-4 col-6 mb-2">
                                                            <div className="d-flex align-items-center">
                                                                <CustomSwitch
                                                                    onChange={() => toggleRecurso(agenda.agenda_id || agenda.id)}
                                                                    checked={recursosSeleccionados.includes(agenda.agenda_id || agenda.id)}
                                                                />
                                                                <span className="ml-2" style={{ fontSize: '14px' }}>
                                                                    {agenda.nombre_agenda && agenda.nombre_agenda.length > 20
                                                                        ? agenda.nombre_agenda.substring(0, 20) + '...'
                                                                        : agenda.nombre_agenda
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {todosLosRecursos.length === 0 && (
                                                    <div className="text-center text-muted">
                                                        <i className="fas fa-info-circle"></i> No hay agendas disponibles para esta fecha
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="contenedor-agenda-recursos" style={{ height: '75vh' }}>

                                        {/* COLUMNA DE HORAS (STICKY) */}
                                        <div className="columna-horas-sticky" dangerouslySetInnerHTML={{ __html: etiquetasHoras }}></div>

                                        {/* AREA DE CONTENIDO (GRID + COLUMNAS) */}
                                        <div className="area-contenido-agenda" style={{ height: alturaAgendaRecursos }}>

                                            {/* FONDO LINEAS (GRID) */}
                                            <div className="fondo-lineas-grid" dangerouslySetInnerHTML={{ __html: bloquesMinutos }}></div>

                                            {/* COLUMNAS DE RECURSOS */}
                                            <div className="flex-columnas-recursos">
                                                {contenidoRecursos}
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>


                <FormNuevaCita
                    modalState={modalState}
                    closeModal={modalState => setModalState('hidden')}
                    profesionalAsignado={profesionalAsignado}
                    nombreProfesionalAsignado={nombreProfesionalAsignado}
                    usuarioAsigna={usuarioAgenda}
                    nombreUsuarioAsigna={nombreUsuarioAsigna}
                    fecha={date}
                    hora={time}
                    reloadCitasAgenda={cargarCitas}
                    extendedProps={extendedProps}
                    primerNombre={primerNombre}
                    segundoNombre={segundoNombre}
                    primerApellido={primerApellido}
                    segundoApellido={segundoApellido}
                    email={email}
                    celular={celular}
                    tipoDocumento={tipoDocumento}
                    numeroDocumento={numeroDocumento}
                    duracionCita={duracionCita}
                    estadoCita={idEstadoCita}
                    unidadAtencion={unidadAtencion}
                    motivoConsulta={motivoConsulta}
                    verCita={verCita}
                    puedeAtender={puedeAtender}
                    idPaciente={idPaciente}
                    primeraVez={primeraVez}
                    idCita={idCita}
                    horaAtencionCita={horaAtencionCita}
                    minutoCita={minutoCita}
                    ampmCita={ampmCita}
                    agendarCitaPaciente={props.agendarCitaPaciente}
                    bloquearProfesional={props.bloquearProfesional}
                    stepCita={stepCita}
                    notificacionCita={toastCita}
                />

                <AgendaTooltip top={tooltipTop} left={tooltipLeft} display={tooltipDisplay} contenido={contenidoTooltip} />

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default VistaPorRecursos;